import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import debounce from 'lodash/debounce';

const useVerticalPageStyles = makeStyles()({
  root: {
    '&::-webkit-scrollbar': {
      display: 'none',
    }
  }
});


export const InfinityScrollItem: React.FC = (props) => (
  <Box
    className="InfinityScrollItem"
    style={{
      scrollSnapAlign: 'start',
      scrollSnapStop: 'always',
      flex: 1
    }}
    {...props}
  />
);


export type InfinityScrollProps = {
  currentSlide?: string;
  onScrollEnd: (direction: 'prev' | 'next') => void;
};


export const InfinityScroll: React.FC<InfinityScrollProps> = ({ currentSlide, onScrollEnd, children }) => {
  const { classes } = useVerticalPageStyles();
  const sRef = React.useRef<HTMLDivElement>();
  const onScrollEndRef = React.useRef(onScrollEnd);
  const [ maxHeight, setMaxHeight ] = React.useState<number>();

  const updateMaxHeight = () => {
    const slide = sRef.current?.querySelectorAll('.InfinityScrollItem')?.[1];

    setMaxHeight(slide?.getBoundingClientRect().height);
  };

  onScrollEndRef.current = onScrollEnd;
  const handleScrollEnd = React.useMemo(() => debounce(() => {
    if (!sRef.current) return;

    if (sRef.current.scrollLeft === 0) {
      onScrollEndRef.current('prev');
      updateMaxHeight();
      sRef.current.scrollTo(sRef.current.getBoundingClientRect().width, 0);
    } else if (sRef.current.scrollLeft === sRef.current.scrollWidth / 3 * 2) {
      onScrollEndRef.current('next');
      updateMaxHeight();
      sRef.current.scrollTo(sRef.current.getBoundingClientRect().width, 0);
    }
  }, 80), []);

  React.useLayoutEffect(() => {
    updateMaxHeight();
  }, [ currentSlide ]);

  return (
    <div
      className={classes.root}
      onScroll={handleScrollEnd}
      ref={el => {
        if (!el) return;

        sRef.current = el;
        el.scrollTo(el.getBoundingClientRect().width, 0);
      }}
      style={{
        width: '100%',
        overflowX: 'scroll',
        scrollSnapType: 'x mandatory',
        maxHeight: maxHeight,
        transitionDuration: '300ms',
        overflowY: 'hidden',
      }}
    >
      <div
        style={{
          width: '300%',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-start',
        }}
      >
        {children}
      </div>
    </div>
  );
};
